import { Axios } from "@lib";
import type {
	ChecklistAnswerPresignedRequest,
	ChecklistAnswerPresignedResponse,
} from "../types";

export const checklistAnswerPresigned = async (
	payload: ChecklistAnswerPresignedRequest
) => {
	const { data } = await Axios.post<ChecklistAnswerPresignedResponse>(
		"/api/checklist/answer/presigned",
		payload
	);

	return data;
};
